import { render, staticRenderFns } from "./ViewOpportunite.vue?vue&type=template&id=27503f12&scoped=true&"
import script from "./ViewOpportunite.vue?vue&type=script&lang=ts&"
export * from "./ViewOpportunite.vue?vue&type=script&lang=ts&"
import style0 from "./ViewOpportunite.vue?vue&type=style&index=0&id=27503f12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27503f12",
  null
  
)

export default component.exports